import {
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoSectionContainer,
    RaikoGridTwoColumn,
    showErrorMessage,
    RaikoFlexFirstChildGrowOne,
    RaikoButtonSecondary,
    RaikoLabel,
    RaikoCreatorInfo,
    convertUniversalDateTimeToPersianDateTime,
    RaikoConfirmDialog, showWarningMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components"
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {FormService} from "../../serverService/formService/FormService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import "./FormDetail.scss"
import RaikoFormFileSelector, {raikoFormFileTypes} from "../../component/raikoFormFileSelector/RaikoFormFileSelector";

export default function FormDetail() {
    const {state} = useLocation()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new FormService()


    const [title, setTitle] = useState(state && state.title ? state.title : RouteHelper.FormDetail.name)
    const [formTitle, setFormTitle] = useState(state && state.title ? state.title : RouteHelper.FormDetail.name)

    const [enabled, setEnabled] = useState(true)
    const [updateButtonLoading, setUpdateButtonLoading] = useState(false)
    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const navigate = useNavigate()

    const {id: formId} = useParams()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getFormDetailFromServer()
        }
    }, []);

    function getFormDetailFromServer() {
        loading.show()
        service.getFormDetail(formId).then(
            response => {
                setFormTitle(response.title)
                setEnabled(response.enabled)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdBy)

                response.forms.map((item, index) => {
                    if (item.extension === "pdf") {
                        setPdfFileName(item.savedName)
                        setPdfFileId(item.id)
                    } else {
                        setWordFileName(item.savedName)
                        setWordFileId(item.id)
                    }
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    //pdf
    const [pdfFileId, setPdfFileId] = useState(-1)
    const [pdfFile, setPdfFile] = useState()
    const [pdfFileName, setPdfFileName] = useState("لطفا فایل pdf مورد نظر را انتخاب نمایید!")
    const [hidePdfFileUploadLoading, setHidePdfFileUploadLoading] = useState(false)
    const [progressPdfFile, setProgressPdfFile] = useState(0)
    const [bufferPdfFile, setBufferPdfFile] = useState(5)

    const [wordFile, setWordFile] = useState(null)
    const [wordFileId, setWordFileId] = useState(-1)
    const [wordFileName, setWordFileName] = useState("لطفا فایل word مورد نظر را انتخاب نمایید!")
    const [hideWordFileUploadLoading, setHideWordFileUploadLoading] = useState(false)
    const [progressWordFile, setProgressWordFile] = useState(0)
    const [bufferWordFile, setBufferWordFile] = useState(5)


    function updateFormDetail() {
        if (formTitle && formTitle.length > 0) {
            loading.show()
            service.updateFormInfo(
                formId,
                formTitle,
                pdfFileId,
                wordFileId,
                pdfFile,
                setProgressPdfFile,
                setHidePdfFileUploadLoading,
                wordFile,
                setProgressWordFile,
                setHideWordFileUploadLoading,
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                setTitle(formTitle)

                response.forms.map((item, index) => {
                    if (item.extension === "pdf") {
                        setPdfFileName(item.savedName)
                        setPdfFileId(item.id)
                        setPdfFile(null)
                    } else {
                        setWordFileName(item.savedName)
                        setWordFileId(item.id)
                        setWordFile(null)
                    }
                })
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا نام فرم را به درستی وارد نمایید.")
        }
    }

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const handleOpenDialog = () => setOpenDeleteDialog(true)
    const handleCloseDialog = () => setOpenDeleteDialog(false)

    function deleteForm() {
        loading.show()
        service.disabledForm(
            formId,
            formTitle,
            pdfFileId,
            wordFileId
        ).then(response => {
            showSuccessMessage("حذف با موفقیت انجام شد.")
            handleCloseDialog()
            navigate(
                RouteHelper.Forms.globalUrl,
                {replace: true}
            )
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.FormDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                openConfirmDialog={openDeleteDialog}
                pageTitle={"حذف فرم"}
                doAction={deleteForm}
                cancelAction={handleCloseDialog}
                warningTitle={"آیا از حذف فرم اطمینان دارید؟"}
            />

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Forms.name,
                                RouteHelper.Forms.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                title,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>

                    </RaikoFlexFirstChildGrowOne>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جزئیات فرم"}
                            hasActionButton={true}
                            actionButtonTitle={"بروزرسانی"}
                            actionButtonOnclick={updateFormDetail}
                            hasSecondaryButton={true}
                            secondaryButtonTitle={"حذف"}
                            secondaryButtonOnClick={handleOpenDialog}
                            actionButtonLoadingState={updateButtonLoading}
                        >
                            <RaikoMaterialOutlinedInput
                                labelText={"عنوان"}
                                value={formTitle}
                                setValue={setFormTitle}
                            />
                            <RaikoLabel text={"فرم ها"}/>
                            <RaikoGridTwoColumn>
                                <RaikoFormFileSelector
                                    file={pdfFile}
                                    setFile={setPdfFile}
                                    fileName={pdfFileName}
                                    setFileName={setPdfFileName}
                                    loading={hidePdfFileUploadLoading}
                                    formType={raikoFormFileTypes.PDF_FILE}
                                    progress={progressPdfFile}
                                    buffer={bufferPdfFile}
                                />

                                <RaikoFormFileSelector
                                    file={wordFile}
                                    setFile={setWordFile}
                                    fileName={wordFileName}
                                    setFileName={setWordFileName}
                                    loading={hideWordFileUploadLoading}
                                    formType={raikoFormFileTypes.WORD_FILE}
                                    progress={progressWordFile}
                                    buffer={bufferWordFile}
                                />
                            </RaikoGridTwoColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoCreatorInfo
                            createdBy={createdBy}
                            createdAt={createdAt}
                        />
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}